import { beSetupAxiosInstance } from '../../axios/beSetupAxios';
import { collectionSetupAxiosInstance } from '../../axios/collectionSetupAxios';
import { APPLICATION_TYPE } from '../../enum/applicationType';

const getIslamicAccountDetailsByAgreementNo = async (requestData: any) => {
  const url = `/redCash/api/v1.0/accountDetails`;
  const res = await collectionSetupAxiosInstance.get(url, {
    params: requestData,
  });
  return res.data;
};

const getIslamicAgreements = async (requestData: any) => {
  const params = {
    filters: requestData?.filters,
    search: requestData?.search,
    sortField: requestData?.sortField,
    sortOrder: requestData?.sortOrder,
    currentPage: requestData?.pagination.current,
    pageSize: requestData?.pagination.pageSize,
  };

  const url = `/redCash/admin/api/v1.0/agreements/company/${process.env.REACT_APP_COMPANY_ID}`;
  const res = await beSetupAxiosInstance.get(url, { params });
  return res.data;
};

const getIslamicPendingSigningAgreements = async (requestData: any) => {
  const params = {
    filters: {
      ...requestData?.filters,
      applicationType: APPLICATION_TYPE.ISLAMIC,
    },
    search: requestData?.search,
    sortField: requestData?.sortField,
    sortOrder: requestData?.sortOrder,
    currentPage: requestData?.pagination.current,
    pageSize: requestData?.pagination.pageSize,
  };

  const url = `/redCash/admin/api/v1.0/agreement/getPendingSigning/company/${process.env.REACT_APP_COMPANY_ID}`;
  const res = await beSetupAxiosInstance.get(url, { params });
  return res.data;
};

const getIslamicSignedAgreements = async (requestData: any) => {
  const params = {
    filters: {
      ...requestData?.filters,
      applicationType: APPLICATION_TYPE.ISLAMIC,
    },
    search: requestData?.search,
    sortField: requestData?.sortField,
    sortOrder: requestData?.sortOrder,
    currentPage: requestData?.pagination.current,
    pageSize: requestData?.pagination.pageSize,
  };

  const url = `/redCash/admin/api/v1.0/agreement/completedSigning/company/${process.env.REACT_APP_COMPANY_ID}`;
  const res = await beSetupAxiosInstance.get(url, { params });
  return res.data;
};

const getIslamicPendingEStampAgreements = async (requestData: any) => {
  const params = {
    filters: {
      ...requestData?.filters,
      clickedDownloadEStampingCert: false,
      applicationType: APPLICATION_TYPE.ISLAMIC,
    },
    search: requestData?.search,
    sortField: requestData?.sortField,
    sortOrder: requestData?.sortOrder,
    currentPage: requestData?.pagination.current,
    pageSize: requestData?.pagination.pageSize,
  };

  const url = `/redCash/admin/api/v1.0/e-stamping/pending`;
  const res = await beSetupAxiosInstance.get(url, { params });
  return res.data;
};

const getIslamicInProgressEStampAgreements = async (requestData: any) => {
  const params = {
    filters: {
      ...requestData?.filters,
      clickedDownloadEStampingCert: true,
      applicationType: APPLICATION_TYPE.ISLAMIC,
    },
    search: requestData?.search,
    sortField: requestData?.sortField,
    sortOrder: requestData?.sortOrder,
    currentPage: requestData?.pagination.current,
    pageSize: requestData?.pagination.pageSize,
  };

  const url = `/redCash/admin/api/v1.0/e-stamping/pending`;
  const res = await beSetupAxiosInstance.get(url, { params });
  return res.data;
};

const getIslamicUploadedEStampAgreements = async (requestData: any) => {
  const params = {
    filters: {
      ...requestData?.filters,
      clickedDownloadEStampingCert: true,
      applicationType: APPLICATION_TYPE.ISLAMIC,
    },
    search: requestData?.search,
    sortField: requestData?.sortField,
    sortOrder: requestData?.sortOrder,
    currentPage: requestData?.pagination.current,
    pageSize: requestData?.pagination.pageSize,
  };

  const url = `/redCash/admin/api/v1.0/e-stamping/completed`;
  const res = await beSetupAxiosInstance.get(url, { params });
  return res.data;
};

const getIslamicAgreementDetails = async (requestData: any) => {
  const { agreementId } = requestData;
  const url = `/redCash/admin/api/v1.0/agreement/${agreementId}/summary`;
  const res = await beSetupAxiosInstance.get(url);
  return res.data;
};

const createIslamicAgreement = async (requestData: any) => {
  const { productCode, payload } = requestData;
  const url = `/redCash/api/v1.0/agreement/product/${productCode}`;
  const res = await beSetupAxiosInstance.post(url, payload);
  return res.data;
};

const searchIslamicDisbursedAgreement = async (requestData: any) => {
  const url = `/redCash/api/v1.0/accountDetails`;
  const res = await collectionSetupAxiosInstance.get(url, requestData);
  return res.data;
};

const approveIslamicEStamping = async (requestData: any) => {
  const { agreementId, language } = requestData;
  const url = `/redCash/admin/api/v1.0/agreement/${agreementId}/${language}/approve-e-stamping`;
  const res = await beSetupAxiosInstance.patch(url);
  return res.data;
};

const clickedDownloadIslamicEStamping = async (requestData: any) => {
  const { agreementId, username } = requestData;
  const url = `/redCash/admin/api/v1.0/agreement/${agreementId}/clicked-download-e-stamping`;
  const res = await beSetupAxiosInstance.patch(
    url,
    {},
    {
      params: { username: username },
    }
  );
  return res.data;
};

const disableIslamicDirectDebit = async (requestData: any) => {
  const { agreementId, accountDetailsId } = requestData;
  const url = `/redCash/api/v1.0/agreement/disableDirectDebit/agreementId/${agreementId}/accountDetailsId/${accountDetailsId}`;
  const res = await beSetupAxiosInstance.patch(url);
  return res.data;
};

const clickedDownloadSmeIslamicEStamping = async (requestData: any) => {
  const { agreementId } = requestData;
  const url = `/redCash/api/v1.0/smeAgreement/${agreementId}/clicked-download-e-stamping`;
  const res = await beSetupAxiosInstance.patch(url, requestData);
  return res.data;
};

const getPendingTradingAgreements = async (requestData: any) => {
  const params = {
    filters: requestData?.filters,
    search: requestData?.search,
    sortField: requestData?.sortField,
    sortOrder: requestData?.sortOrder,
    currentPage: requestData?.pagination.current,
    pageSize: requestData?.pagination.pageSize,
  };

  const url = `/redCash/admin/api/v1.0/agreements/pending-trading`;
  const res = await beSetupAxiosInstance.get(url, { params });
  return res.data;
};

const islamicAgreementService = {
  getIslamicAgreements,
  getIslamicPendingSigningAgreements,
  getIslamicSignedAgreements,
  getIslamicPendingEStampAgreements,
  getIslamicInProgressEStampAgreements,
  getIslamicUploadedEStampAgreements,
  getIslamicAgreementDetails,
  createIslamicAgreement,
  searchIslamicDisbursedAgreement,
  approveIslamicEStamping,
  clickedDownloadIslamicEStamping,
  disableIslamicDirectDebit,
  clickedDownloadSmeIslamicEStamping,
  getIslamicAccountDetailsByAgreementNo,
  getPendingTradingAgreements,
};

export default islamicAgreementService;
